import { isNil } from 'ramda';
import { select } from 'd3-selection';
import { adjustAutoSpace } from './axes.helper';

export function axis(el, binding) {
  const { axisScale, x, y, custom, type, isAuto, overflow, setSpace } = binding.value;

  select(el).call(axisScale);

  const items = select(el)
    .selectAll('.tick text')
    .attr('text-anchor', null);

  if (!isNil(overflow) && !overflow) {
    items.filter((_, index) => index === 0).attr('text-anchor', 'start');

    const lastIndex = items.size() - 1;

    items.filter((_, index) => index === lastIndex).attr('text-anchor', 'end');
  }

  if (custom) {
    custom(el, { axisScale, x, y });
  }

  if (isAuto) {
    adjustAutoSpace(el, type, setSpace);
  }
}
